import { render, staticRenderFns } from "./ListShippingsRequestComponent.vue?vue&type=template&id=dcbc911c&scoped=true&"
import script from "./ListShippingsRequestComponent.vue?vue&type=script&lang=js&"
export * from "./ListShippingsRequestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc911c",
  null
  
)

export default component.exports